import {
  ownerList,
  useOwnerGet,
  useOwnerGetSuspense,
  useOwnerListSuspense,
  useOwnerUpdateAdminMemo,
} from "@/api/generated/endpoints/api"
import {
  OwnerGetWithOperationRules,
  OwnerGetWithOperationRulesOperationRuleLogs,
  OwnerGetWithProperties,
  OwnerGetWithPropertiesRooms,
  OwnerListIsEchoesOwner,
  OwnerListWithProperties,
} from "@/api/generated/models"

import { ownerListQueryParams } from "@/api/generated/schemas/api.zod"

// API hooks and functions
export const ownerApi = {
  // Mutation hooks
  useOwnerListSuspense,
  useOwnerGet,
  useOwnerGetSuspense,
  useOwnerUpdateAdminMemo,

  // Direct API functions
  ownerList,
}

export const ownerProperties = {
  OwnerListWithProperties,
  OwnerListIsEchoesOwner,
  OwnerGetWithProperties,
  OwnerGetWithPropertiesRooms,
  OwnerGetWithOperationRules,
  OwnerGetWithOperationRulesOperationRuleLogs,
}

export const ownerSchemas = {
  ownerListQueryParams,
}

export * as OwnerModels from "./models"
